module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"plan":{"free":"You will get the Free license (only 10 contacts converted)","month":"You will get the 30 days license (unlimitted contacts & conversions)","lifetime":"You will get the Lifetime license (unlimitted contacts & conversions)"},"placeholders":{"email":"E-mail","password":"Password"},"cta":"Create my account"}}')
  delete Component.options._Ctor
}
